import { COSTCENTRES_URL } from '../constants';
import { apiSlice } from './apiSlice';

export const costcentresApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getCostcentres: builder.query({
            query: ({ keyword, pageNumber }) => ({
                url: COSTCENTRES_URL,
                params: { keyword, pageNumber },
            }),
            keepUnusedDataFor: 5,
            providesTags: ['TheCostcentres'],
        }),

        getCostcentresNoPage: builder.query({
            query: () => ({
                url: `${COSTCENTRES_URL}/list`,

            }),
            keepUnusedDataFor: 5,
            providesTags: ['TheCostcentres'],
        }),




        getCostcentresDetails: builder.query({
            query: (costcentreId) => ({
                url: `${COSTCENTRES_URL}/${costcentreId}`,
            }),
            keepUnusedDataFor: 5,
        }),
        createCostcentres: builder.mutation({
            query: () => ({
                url: `${COSTCENTRES_URL}`,
                method: 'POST',
            }),
            invalidatesTags: ['TheCostcentres'],
        }),
        updateCostcentres: builder.mutation({
            query: (data) => ({
                url: `${COSTCENTRES_URL}/${data.costcentreId}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['TheCostcentres'],
        }),
        deleteCostcentres: builder.mutation({
            query: (costcentreId) => ({
                url: `${COSTCENTRES_URL}/${costcentreId}`,
                method: 'DELETE',
            }),
            providesTags: ['TheCostcentres'],
        }),


    }),
});

export const {
    useGetCostcentresQuery,
    useGetCostcentresNoPageQuery,
    useGetCostcentresDetailsQuery,
    useCreateCostcentresMutation,
    useUpdateCostcentresMutation,
    useDeleteCostcentresMutation,

} = costcentresApiSlice;
